module.exports = __webpack_public_path__ + "img/clf_sj.bee78f13.jpg";